require.register("local-data/assessments/phd-qafeedback-IL", function(exports, require, module){
  module.exports = {
    "seed": "2a294251-217c-4ca7-87fe-ef78cac7fa0b",
    "questions": [
      {
        "id": 1,
        "text": "How often do you think people make deliberately false accusations?",
        "correct_answer": "C",
        "answers": [
          { "id": "A", 
            "text": "All the time.", 
            "correct": false, 
            "feedback": {
              "region": "response",
              "incorrect": {
                "blocks": [{
                    "type":"text",
                    "items": [{"description": "failure feedback"}]
                }]
              }
            }
          },
          { "id": "B",
            "text": "Sometimes",
            "correct": false,
            "feedback": {
              "region": "response",
              "incorrect": {
                "blocks": [{
                    "type":"text",
                    "items": [{"description": "failure feedback"}]
                }]
              }
            }
          },
          { "id": "C", 
            "text": "Rarely", 
            "correct": true, 
            "feedback": {
              "region": "response",
              "incorrect": {
                "blocks": [{
                    "type":"text",
                    "items": [{"description": "success feedback"}]
                }]
              }
            }
          }
        ]
      }
    ]
  };

  
});

